<div class="validateform">
  <ul role="list" [formGroup]="formGroup" style="list-style-type:none;padding: 0;">
    <!-- Conditional Form Groups: `detailInfo.isHiddenByCurrentVariant` is updated
         imperatively by applyVariantVisibilityToFormGroup when the active variant changes;
         we read the flag directly so we don't re-run the variant lookup per CD cycle. -->
    <!-- Derived fields (contact Age and the like) are computed server-side and never stored, so
         they get no form control — see isDerivedReadOnlyField. Rendering one would look for a
         control that isn't there, and there is nothing to edit in any case. They still appear on
         the read-only record view, which builds its own display. -->
    <ng-container *ngFor="let detailInfo of detailInfoList; let i = index">
      <li *ngIf="!isDerivedReadOnlyField(detailInfo)"
          [class.d-none]="detailInfo.isHiddenByCurrentVariant">
        <app-detail-info-type-container [detailInfo]="detailInfo" [class.d-none]="detailInfo.isHidden"
          [formGroup]="formGroup" class="w-100">
        </app-detail-info-type-container>
      </li>
    </ng-container>
  </ul>
</div>